import styled from 'styled-components';

import { Text } from 'features/common/components/Text';
import { ExtraWidthProp, IsDraft } from '../../types';

export const CampaignContainer = styled.div<IsDraft & { isSent?: boolean; isFailed?: boolean; isPunchup?: boolean }>`
	box-sizing: border-box;
	cursor: ${({ isDraft, isSent, isFailed }) => (isDraft || isSent || isFailed) && 'pointer'};
	display: flex;
	align-items: center;
	justify-content: space-between;
	background-color: ${({ theme, isPunchup, isFailed }) => {
		if (isFailed && isPunchup) return '#fff5f5';
		if (isPunchup) return '#f5f5f5';
		return theme.colors.grey2;
	}};
	border: ${({ isPunchup, isFailed }) => {
		if (isFailed && isPunchup) return '1px solid #ffcccc';
		if (isPunchup) return '1px solid #e5e5e5';
		return 'none';
	}};
	border-radius: ${({ isPunchup }) => (isPunchup ? '8px' : '0')};
	max-width: 1300px;
	width: 100%;
	padding: 42px 32px;
`;

export const InfoFlex = styled.div`
	align-items: center;
	display: flex;
	gap: 16px;
	justify-content: space-between;
	width: calc(100% - 25px);
	max-width: 1000px;
`;

export const LabeledGroup = styled.div<ExtraWidthProp>`
	display: flex;
	flex-direction: column;
	height: 48px;
	line-height: normal;
	width: ${({ extraWidth }) => (extraWidth ? '30%' : '90px')};
`;

export const Label = styled(Text)<{ isPunchup?: boolean }>`
	color: ${({ theme, isPunchup }) => (isPunchup ? '#999' : theme.colors.lightGrey10)};
	font-size: 14px;
	font-weight: 500;
	text-transform: uppercase;
	line-height: normal;
`;

export const InfoText = styled(Text)<ExtraWidthProp & { isPunchup?: boolean }>`
	font-size: 18px;
	font-weight: 600;
	line-height: normal;
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
	width: ${({ extraWidth }) => (extraWidth ? '30%' : '100%')};
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
`;

export const StatsContainer = styled.div<{ isPunchup?: boolean }>`
	background-color: ${({ theme, isPunchup }) => (isPunchup ? '#fafafa' : theme.colors.grey)};
	max-width: 1300px;
	width: 100%;
	padding: 24px 32px;
	border-top: 1px solid ${({ theme, isPunchup }) => (isPunchup ? '#e5e5e5' : theme.colors.grey3)};
	border-radius: ${({ isPunchup }) => (isPunchup ? '0 0 8px 8px' : '0')};
`;

export const StatsGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
	gap: 24px;
`;

export const StatsItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;
